<template>
  <v-container grid-list-md fluid pa-0>
    <new-expense :visibility.sync="newDialog" :expense="expense" @saved="getExpenses" />
    <v-layout
      row
      wrap
      align-center
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          v-debounce:500ms="getExpenses"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="newDialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Expense</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :total-items="expenses.meta.total"
          :pagination.sync="pagination"
          :headers="headers"
          :items="expenses.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.description}}</td>
              <td>{{ props.item.amount }}</td>
              <td>{{ props.item.category.name }}</td>
              <td>{{props.item.date | moment('YYYY-MM-DD') }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editExpense(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewExpense from "./new";
export default {
  components: {
    NewExpense
  },
  data() {
    return {
      newDialog: false,
      expense: null,
      search: "",
      pagination: {
        descending: true
      },
      headers: [
        { text: "#", value: "id" },
        { text: "Description", value: "description" },
        { text: "Amount", value: "amount" },
        { text: "Category", value: "category.name", sortable: false },
        { text: "Date", value: "date" },
        { text: "", value: "name", sortable: false, width: 200 }
      ],
      expenses: {
        data: [],
        meta: {},
        links: {}
      }
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getExpenses();
      }
    }
  },
  methods: {
    getExpenses() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/expenses?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;

      this.getDataFromApi(query);
    },
    async getDataFromApi(path) {
      const { data } = await this.axios.get(path);
      if (data) this.expenses = data;
    },
    confirmDelete(expense) {
      const params = {
        title: `Delete "${expense.description}"`,
        message: `Are you sure, you want to delete the expense "${expense.description}"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deleteExpense(expense)
      };

      this.$modal.show(params);
    },

    async deleteExpense(expense) {
      await this.axios.delete(`api/expenses/${expense.id}`);
      this.getExpenses();
    },

    editExpense(expense) {
      Object.assign(this.expense, expense)
      this.newDialog = true;
    }
  },
  mounted() {
    if (this.$route.query.new) {
      this.newDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>